import React from "react";

import { Button } from "antd";

import CheckoutProcessingModal from "./CheckoutProcessingModal";

import { formatCurrency } from "../utils";

import "./UsageMetricsPaymentSummary.css";

// TEMP: offers / savings badge hidden for now.
// const getSavingsLabel = (savings, freeOffers) => {
//   const hasSavings = savings > 0;
//   const hasOffers = freeOffers > 0;
//
//   if (hasSavings && hasOffers) {
//     return `You saved ${formatCurrency(savings)} + earned ${freeOffers} free offers`;
//   }
//   if (hasSavings) {
//     return `You saved ${formatCurrency(savings)}`;
//   }
//   if (hasOffers) {
//     return `You earned ${freeOffers} free offers`;
//   }
//   return null;
// };

export default function UsageMetricsPaymentSummary({
  total = 0,
  // savings = 0,
  // freeOffers = 0,
  onContinue,
  loading = false,
  onCancelPayment,
  paymentUrl,
}) {
  // const savingsLabel = getSavingsLabel(savings, freeOffers);

  return (
    <>
      <div className="UsageMetricsPaymentSummary">
        {/* <div className="UsageMetricsPaymentSummary__Leading">
        {savingsLabel && (
          <span className="UsageMetricsPaymentSummary__Savings">
            {savingsLabel}
          </span>
        )}
      </div> */}

        <div className="UsageMetricsPaymentSummary__Trailing">
          <span className="UsageMetricsPaymentSummary__Total">
            {`Total - ${formatCurrency(total)}`}
          </span>

          <Button
            type="primary"
            className="UsageMetricsPaymentSummary__ContinueButton"
            onClick={onContinue}
            disabled={total <= 0 || loading}
          >
            Continue with payment
          </Button>
        </div>
      </div>

      <CheckoutProcessingModal
        open={loading}
        onCancelPayment={onCancelPayment}
        paymentUrl={paymentUrl}
      />
    </>
  );
}
